import { AnalyticsService, Flavor, IRecommendationArgs, recommendation } from "@gtmhub/core/analytics";
import { IIndicator } from "@gtmhub/error-handling";
import { IMarketplaceInsightboardTemplate, InsightboardService, PreviewInsightboardTemplateModal } from "@gtmhub/insightboards";
import { StateService } from "@uirouter/angularjs";
import { IComponentOptions, IController } from "angular";

export interface IFeaturedInsightboardBindings {
  insightboardTemplate: IMarketplaceInsightboardTemplate;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface FeaturedInsightboardCtrl extends IFeaturedInsightboardBindings {}
export class FeaturedInsightboardCtrl implements IController {
  indicators: {
    adding?: IIndicator;
  };

  static $inject = ["$state", "PreviewInsightboardTemplateModal", "InsightboardService", "AnalyticsService"];

  constructor(
    private $state: StateService,
    private previewInsightboardTemplateModal: PreviewInsightboardTemplateModal,
    private insightboardService: InsightboardService,
    private analyticsService: AnalyticsService
  ) {
    this.indicators = {};
  }

  addInsightboardTemplate(): void {
    this.indicators.adding = { progress: true };

    this.insightboardService.installMarketplaceInsightboards([this.insightboardTemplate.id]).then(
      (installedInsightboards) => {
        this.trackRecommendationHelpfulness({ isUseful: true });
        this.$state.go("gtmhub.insightboard", { dashboardId: installedInsightboards.installedInsightboards[0].id });
        delete this.indicators.adding;
      },
      (error) => (this.indicators.adding = { error })
    );
  }

  private trackRecommendationHelpfulness(args: IRecommendationArgs): void {
    //Tracking Insightboards creation recommendation helpfulness. Recommendation is helpful if user selects an insightboard from templates
    this.analyticsService.track(recommendation, {
      is_useful: args.isUseful,
      flavor: Flavor.PASSIVE,
      action: "creates_insightboard",
    });
  }

  previewInsightboardTemplate(): void {
    this.previewInsightboardTemplateModal.open(this.insightboardTemplate, this.addInsightboardTemplate.bind(this));
  }

  resetIndicator(indicator: keyof FeaturedInsightboardCtrl["indicators"]): void {
    delete this.indicators[indicator];
  }
}

export const FeaturedInsightboardComponent: IComponentOptions = {
  bindings: {
    insightboardTemplate: "<",
  },
  controller: FeaturedInsightboardCtrl,
  templateUrl: require("./featured-insightboard.jade"),
};
